// Граница ошибок рендера.
//
// Без неё любое исключение в компоненте размонтирует всё дерево, и внутри
// Telegram остаётся пустой белый экран — без объяснения и без выхода.
// Перезагрузить Mini App оттуда неочевидно: адресной строки нет.
//
// Экран отказа говорит, что произошло и что сделать, и не извиняется.
// Техническое сообщение показываем свёрнутым: пользователю оно не нужно,
// но без него невозможно рассказать, что именно сломалось.

import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // Консоль — единственное место, куда это попадёт: отдельного клиентского
    // сборщика ошибок в проекте нет.
    console.error('Render error:', error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="crash">
        <h1 className="crash-title">Экран не открылся</h1>
        <p className="crash-text">
          Что-то сломалось при отрисовке. Данные целы — не записалось и не удалилось ничего.
        </p>
        <button type="button" className="crash-btn" onClick={() => window.location.reload()}>
          Перезагрузить
        </button>
        <details className="crash-details">
          <summary>Подробности</summary>
          <pre>{error.message}</pre>
        </details>
      </div>
    );
  }
}
